




import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import VueRouter from "vue-router";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useUserStore } from "@/shared/store/user";

@Component({})
export default class EmailVerify extends Vue {
  $router: VueRouter;

  contactInfoStore = useContactInfoStore();
  userStore = useUserStore();

  @Prop() emailVerificationCode: string;
  @Prop() routeToHome: string;


  created () {
    this.verifyEmail();
  }

  ensureNotLoggedIn () {
    return this.userStore.loggedIn ? this.userStore.logout() : Promise.resolve();
  }

  verifyEmail () {
    this.ensureNotLoggedIn()
        .then(_ => {
          if (this.emailVerificationCode) {
            this.contactInfoStore.verifyEmailChange(this.emailVerificationCode)
                .finally(() => this.$router.replace(this.routeToHome));
            return;
          }
          this.$router.replace(this.routeToHome);
        });
  }
}
